/* M-District v122: keep announcement texts on one line.
 * If a text is wider than the bar, it slides from right to left (one pass), then the bar
 * moves on to the next announcement. Rotation is held while the text is moving.
 * Works with announcement-bar-component (assets/announcement-bar.js). */
(function () {
  if (window.mdAnnouncementMarquee) return;
  window.mdAnnouncementMarquee = true;

  var SPEED = 45; /* px per second */
  var HOLD_START = 1200; /* ms before moving */
  var HOLD_END = 1500; /* ms after the end is visible */
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(bar) {
    var slides = bar.querySelectorAll('.announcement-bar__slide');
    if (!slides.length) return;
    var running = null;
    var timers = [];

    function clearTimers() {
      timers.forEach(function (t) { window.clearTimeout(t); });
      timers = [];
    }

    function reset(slide) {
      slide.classList.remove('md-mq', 'md-mq--run');
      slide.style.removeProperty('--md-mq-to');
      slide.style.removeProperty('--md-mq-dur');
    }

    function holdRotation() {
      if (typeof bar.suspend === 'function') bar.suspend();
    }

    function releaseRotation(advance) {
      if (advance && slides.length > 1 && typeof bar.next === 'function') bar.next();
      if (typeof bar.resume === 'function') bar.resume();
    }

    function run(slide) {
      clearTimers();
      if (running && running !== slide) reset(running);
      running = null;
      reset(slide);
      var text = slide.querySelector('.announcement-bar__text');
      if (!text) return;
      slide.classList.add('md-mq'); /* left-aligned, so the full overflow can be measured */
      var overflow = text.scrollWidth - text.clientWidth;
      if (overflow <= 2) {
        slide.classList.remove('md-mq');
        return;
      }
      if (reduced) return;
      running = slide;
      var dur = Math.max(2, overflow / SPEED);
      slide.style.setProperty('--md-mq-to', -Math.ceil(overflow) + 'px');
      slide.style.setProperty('--md-mq-dur', dur + 's');
      holdRotation();
      timers.push(window.setTimeout(function () {
        slide.classList.add('md-mq--run');
        timers.push(window.setTimeout(function () {
          running = null;
          releaseRotation(true);
          timers.push(window.setTimeout(function () { reset(slide); }, 600));
        }, dur * 1000 + HOLD_END));
      }, HOLD_START));
    }

    function active() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('aria-hidden') !== 'true') return slides[i];
      }
      return null;
    }

    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var s = records[i].target;
        if (s.getAttribute('aria-hidden') === 'false') { run(s); break; }
      }
    });
    for (var j = 0; j < slides.length; j++) {
      observer.observe(slides[j], { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    /* The component resumes rotation on mouseleave; keep holding while text is moving. */
    bar.addEventListener('mouseleave', function () {
      if (running) window.setTimeout(holdRotation, 0);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        var a = active();
        if (a) run(a);
      }, 250);
    });

    var first = active();
    if (first) run(first);
  }

  function start() {
    var bars = document.querySelectorAll('announcement-bar-component');
    for (var i = 0; i < bars.length; i++) setup(bars[i]);
  }

  function whenReady() {
    if (window.customElements && customElements.whenDefined && document.querySelector('announcement-bar-component')) {
      var done = false;
      customElements.whenDefined('announcement-bar-component').then(function () { if (!done) { done = true; start(); } });
      /* single announcement: the component script is not loaded, start anyway */
      window.setTimeout(function () { if (!done) { done = true; start(); } }, 1500);
    } else {
      start();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', whenReady);
  } else {
    whenReady();
  }
})();
